// extracted by mini-css-extract-plugin
module.exports = {"header-bg-image":"j","headerBgImage":"j","header-bg":"k","headerBg":"k"};